module.exports = __webpack_public_path__ + "static/img/contract-item.aa385ed7.png";